import React, { Children, useState } from 'react';
import { Field, reduxForm } from 'redux-form//immutable';
import { useDispatch, useSelector } from 'react-redux';
import { validate } from './utils';
import it from 'date-fns/esm/locale/it/index.js';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import { Dropdown } from '@/components/Dropdown';
import styles from './Projects.module.scss';
import { Input } from '@/components/Input';
import { Button, buttonVariants } from '@/components/Button';
const dropdownStyles = {
  container: {
    border: '1px solid #E0E4EA',
  },
  option: {
    backgroundColor: '#fafafa',
  },
  valueContainer: {
    height: '42px',
  },
  control: {
    height: '42px',
  },
};
const priorityOptions = [
  { value: 'P1', label: 'P1' },
  { value: 'P2', label: 'P2' },
  { value: 'P3', label: 'P3' },
  { value: 'P4', label: 'P4' },
];
const statusOptions = [
  { value: 'TO DO', label: 'TO DO' },
  { value: 'IN PROGRESS', label: 'IN PROGRESS' },
  { value: 'QA', label: 'QA' },
  { value: 'DONE', label: 'DONE' },
];

const errorMessage = {
  team: 'Please select a team',
  title: 'Please enter a title',
  summery: 'Please enter a summery',
  status: 'Please select a status',
  priority: 'Please select a priority',
  assignee: 'Please select an assignee',
};
const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning },
}) => (
  <div>
    <label className="control-label">{label}</label>
    <div>
      <input
        {...input}
        placeholder={label}
        type={type}
        className="form-control"
      />
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
);

const renderStatusField = ({
  input,
  label,
  type,
  children,
  meta: { touched, error, warning },
}) => (
  <div>
    <label className="control-label">{label}</label>
    <div>
      <select
        {...input}
        placeholder={label}
        type={type}
        className="form-control"
      >
        {children}
      </select>
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
);

const TaskForm = ({
  handleCloseEventModal,
  handleSubmit,
  submitting,
  members,
  project,
}) => {
  const team = useSelector((state) => ({
    teams: state.team.teams,
    activeTeam: state.team.activeTeam,
    selectedTeamId: state.team.selectedTeamID,
    projects: state.team.projects,
  }));

  const { activeCompany } = useSelector((state) => state.auth.profile);
  const dispatch = useDispatch();
  const statusOptions = ['TO DO', 'IN PROGRESS', 'QA', 'DONE'];
  const priorityOptions = ['P1', 'P2', 'P3', 'P4'];
  const newData = [];
  console.log('Members : ', members);
  const newMembers = [...members];

  team.projects.map((item) => {
    if (!item.data.deleted) {
      const obj = {
        name: item.data.project_name,
        id: item.id,
      };
      newData.push(obj);
    }
  });

  return (
    <div>
      <form
        onSubmit={handleSubmit((values) => {
          handleCloseEventModal();
          dispatch({
            type: teamActionTypes.ADD_TASKS,
            payload: {
              companyId: activeCompany.companyId,
              projectId: 'activeCompany.companyId',
              value: { ...values, teamId: team.selectedTeamId },
            },
          });
        })}
      >
        <Field
          name="team"
          component={renderStatusField}
          label="Team"
          className="mb-3 form-control  form-control-sm"
          placeholder="Project Title"
        >
          <option>Select team</option>
          {newData.map((x) => (
            <option key={x.id} value={x.id}>
              {x.name}
            </option>
          ))}
        </Field>
        <Field
          type="text"
          name="task"
          label="Title"
          className="mb-3 form-control form-control-sm"
          component={renderField}
          placeholder="Task Title"
        />
        <Field
          type="text"
          name="summery"
          label="Summery"
          className="mb-3 form-control form-control-sm"
          component={renderField}
          placeholder="Task Summery"
        />
        <Field
          name="status"
          component={renderStatusField}
          label="Status"
          className="mb-3 form-control  form-control-sm"
          placeholder="status"
        >
          <option>Select status</option>

          {statusOptions.map((x, i) => (
            <option key={i} value={x}>
              {x}
            </option>
          ))}
        </Field>
        <Field
          name="priority"
          component={renderStatusField}
          label="Priority"
          className="mb-3 form-control  form-control-sm"
          placeholder="Priority"
        >
          <option>Select priority</option>

          {priorityOptions.map((x, i) => (
            <option key={i} value={x}>
              {x}
            </option>
          ))}
        </Field>
        <Field
          name="assignee"
          component={renderStatusField}
          label="Assignee"
          className="mb-3 form-control  form-control-sm"
          placeholder="assignee"
        >
          <option>Select assignee</option>

          {newMembers.map((x, i) => (
            <option key={i} value={x.userUID}>
              {x.userName}
            </option>
          ))}
        </Field>
        <Button
          text="Create Task"
          variant={buttonVariants.primary}
          type="submit"
        />
        {/* <Button
          disabled={submitting}
          color="primary"
          type="submit"
          size="sm"
          className="mt-2"
        >
          Create Task
        </Button> */}
      </form>
    </div>
  );
};

export const AddTaskForm = ({
  handleCloseEventModal,
  submitting,
  members,
  project,
}) => {
  const [formValues, setFormValues] = useState({
    team: null,
    title: null,
    summery: null,
    status: null,
    priority: null,
    assignee: null,
  });
  const [formErrors, setFormErrors] = useState({});

  const team = useSelector((state) => ({
    teams: state.team.teams,
    activeTeam: state.team.activeTeam,
    selectedTeamId: state.team.selectedTeamID,
    projects: state.team.projects,
  }));

  const { activeCompany } = useSelector((state) => state.auth.profile);
  const dispatch = useDispatch();
  const handleSubmit = () => {
    const formKeys = [
      'team',
      'title',
      'summery',
      'status',
      'priority',
      'assignee',
    ];
    const errors = {};
    for (const key of formKeys) {
      if (!formValues[key]) {
        errors[key] = errorMessage[key];
      }
    }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});
    dispatch({
      type: teamActionTypes.ADD_TASKS,
      payload: {
        companyId: activeCompany.companyId,
        projectId: 'activeCompany.companyId',
        value: {
          assignee: formValues.assignee?.value,
          priority: formValues.priority?.value,
          status: formValues.status?.value,
          summery: formValues.summery,
          title: formValues.title,
          team: formValues.team?.value,
          teamId: team.selectedTeamId,
        },
      },
    });
  };

  const newData = [];
  console.log('Members : ', members);
  const newMembers = [...members].map((member) => ({
    ...member,
    value: member.userUID,
    label: member.userName,
  }));
  team?.projects?.forEach((item) => {
    if (!item.data.deleted) {
      const obj = {
        name: item.data.project_name,
        id: item.id,
        value: item.data.project_name,
        label: item.data.project_name,
      };
      newData.push(obj);
    }
  });
  return (
    <div className={styles.addTaskForm}>
      <Dropdown
        options={newData}
        value={formValues.team}
        label={'Team'}
        selectStyles={dropdownStyles}
        onChange={(option) => {
          setFormValues({ ...formValues, team: option });
          setFormErrors({ ...formErrors, team: null });
        }}
        errorMessage={formErrors.team}
      />
      <Input
        label="Title"
        name="title"
        value={formValues.title}
        placeholder="Task Title"
        onChange={(e) => {
          setFormValues({ ...formValues, title: e.target.value });
          setFormErrors({ ...formErrors, title: null });
        }}
        errorMessage={formErrors.title}
      />
      <Input
        label="Summery"
        name="summery"
        value={formValues.summery}
        placeholder="Task Summery"
        onChange={(e) => {
          setFormValues({ ...formValues, summery: e.target.value });
          setFormErrors({ ...formErrors, summery: null });
        }}
        errorMessage={formErrors.summery}
      />
      <Dropdown
        options={statusOptions}
        value={formValues.status}
        label={'Status'}
        selectStyles={dropdownStyles}
        onChange={(option) => {
          setFormValues({ ...formValues, status: option });
          setFormErrors({ ...formErrors, status: null });
        }}
        errorMessage={formErrors.status}
      />
      <Dropdown
        options={priorityOptions}
        value={formValues.priority}
        label={'Priority'}
        selectStyles={dropdownStyles}
        onChange={(option) => {
          setFormValues({ ...formValues, priority: option });
          setFormErrors({ ...formErrors, priority: null });
        }}
        errorMessage={formErrors.priority}
      />
      <Dropdown
        options={newMembers}
        value={formValues.assignee}
        label={'Select assignee'}
        selectStyles={dropdownStyles}
        onChange={(option) => {
          setFormValues({ ...formValues, assignee: option });
          setFormErrors({ ...formErrors, assignee: null });
        }}
        errorMessage={formErrors.assignee}
      />
      <Button
        text="Create Task"
        variant={buttonVariants.primary}
        onClick={() => handleSubmit(formValues)}
        // disabled={Object.keys(formErrors).length > 0}
      />
    </div>
  );
};
export default reduxForm({
  form: 'TaskForm',
  validate,
})(TaskForm);
